import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './index.css'
import './i18n'
import App from './App.tsx'
import { ApiError } from './lib/api'

// Retry only transient failures (network drop, 5xx). Deterministic 4xx — a lost
// funnel session (401), bad origin (403), or gating (409) — won't succeed on
// retry; retrying them just delays the error by seconds and makes a failed save
// feel slower. Fail those fast so the user (or our telemetry) sees the real code.
const retryTransient = (count: number, error: unknown) =>
  count < 2 && (!(error instanceof ApiError) || error.status >= 500)

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: retryTransient, staleTime: 30_000, refetchOnWindowFocus: false }, mutations: { retry: retryTransient } } })

window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  if (sessionStorage.getItem('bonded_preload_reloaded') !== '1') {
    sessionStorage.setItem('bonded_preload_reloaded', '1')
    window.location.reload()
  }
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}><App /></QueryClientProvider>
  </StrictMode>,
)
